import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { DBImportType } from '@/types/import';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '@/utils';
import type { WriteRequestOptions } from '../requestOptions';

const validate = (importType: string, token: string) => {
  if (!importType) {
    throw new Error('`importType` is required');
  }
  if (!token) {
    throw new Error('`token` is required');
  }
};

type RequestParams = {
  importType: DBImportType;
  token: string;
  profile?: number;
  upsert?: boolean;
  delete?: boolean;
  skip_unmatched?: boolean;
  delay?: boolean;
};

type Response = Record<string, unknown>;

export const finalizeImportPreview = async (
  scope: RequestScope,
  { importType, token, profile, upsert, delete: deleteFlag, skip_unmatched, delay }: RequestParams,
  requestOptions: WriteRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    validate(importType, token);

    const body: Record<string, unknown> = {};
    if (profile !== undefined) body.profile = profile;
    if (upsert !== undefined) body.upsert = upsert;
    if (deleteFlag !== undefined) body.delete = deleteFlag;
    if (skip_unmatched !== undefined) body.skip_unmatched = skip_unmatched;
    if (delay !== undefined) body.delay = delay;

    const result = await scopedApi(scope).post<EndpointResponse<Response>>(`import_preview/${importType}/${token}/finalize`, body, requestOptions);
    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
